import { _ } from '@splunk/ui-utils/i18n';
import {
    AbsoluteLayout,
    AbsoluteLayoutApi,
    GridLayout,
    GridLayoutApi,
} from '@splunk/dashboard-layouts';
import type { PresetMap } from '@splunk/dashboard-types';

import { withInitialShowGrid, withLayoutConfig } from './utils';

export default {
    layouts: {
        absolute: withLayoutConfig(withInitialShowGrid(AbsoluteLayout), {
            description: _('pixel level control'),
            name: _('Absolute'),
            layoutApi: AbsoluteLayoutApi,
        }),
        grid: withLayoutConfig(
            withInitialShowGrid(GridLayout, { value: false }),
            {
                description: _('quick organization'),
                name: _('Grid'),
                layoutApi: GridLayoutApi,
                scrollOnItemAdd: true,
            }
        ),
    } as PresetMap['layouts'],
};
